import React from 'react';
import {useTranslation} from 'react-i18next';
import TitleValue from '../title-value/TitleValue.component';

export default function Plaque(props) {
  const {t} = useTranslation();

  return <TitleValue title={t('license_plate')} {...props} />;
}
